import { renderToStaticMarkup } from "react-dom/server";

import { getTaxYearRange } from "./date";
import TaxSummaryContent from "../components/pages/Questionnaire/components/Submit/TaxSummaryContent";

export const getPdfHtml = (currentDocumentYear: string, user: any, taxData: any) => {
    const { end } = getTaxYearRange(currentDocumentYear);
    const contentHtml = renderToStaticMarkup(
        <>
            <h1>
                Self-Assessment: Tax Calculation{" "}
                <span style={{ fontWeight: "normal", fontSize: "16px" }}>
                (SA302 equivalent)</span>
            </h1>
            <h2>
                Tax Calculation for {currentDocumentYear} (year ended 5 April {end})
            </h2>
            <TaxSummaryContent
                user={user}
                taxData={taxData}
                isVisible={false}
                handleClick={() => {
                }}
            />
        </>
    );
    const cleanedContentHtml = contentHtml.replace(/<img[^>]*>/g, "");
    return `
              <!DOCTYPE html>
              <html>
                <head>
                  <meta charset="utf-8" />
                  <style>
                    .ant-card {
                      page-break-inside: avoid;
                      break-inside: avoid;
                    }
            
                    body {
                      margin: 0;
                      padding: 0;
                    }
            
                    .ant-card {
                      padding: 20px;
                      margin: 20px;
                      border: 1px solid #ccc;
                      border-radius: 10px;
                      font-family: sans-serif;
                    }
                  </style>
                </head>
                <body>
                  ${cleanedContentHtml}
                </body>
              </html>
            `;
};

export const generatePdfFromBlob = (pdfBlob: any) => {
    const url = window.URL.createObjectURL(pdfBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "tax-summary.pdf";
    link.click();
    window.URL.revokeObjectURL(url);
};
